var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('payer-info',{attrs:{"module":_vm.module}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }